import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors } from '@codex/themes';
import { Icon } from '@codex/icons';

const ProductImageAndNameCellContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const RemoveButton = styled.button`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors.link.default};
  padding-top: 5px;
  display: inline-block;
  text-decoration: none;
  border: 0;
  margin-bottom: 7px;
  height: auto;
  display: flex;
  align-items: center;
  
  span {
    width: 20px;
    height: 20px;
  }
`;

const ProductTitleLink = styled.a`
  text-decoration: none;
  color: ${colors.shades[2]};
  &:hover {
    text-decoration: underline;
  }
`;

const ProductImage = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  display: block;
  cursor: pointer;
  border: 0;
  width: 150px;
`;

const ProductTitle = styled.strong`
  display: block;
  font-weight: bold;
  color: ${colors.primary.default};
  cursor: pointer;
  text-decoration: none;
  margin: 0 0 5px;
  line-height: 1.2;
  text-align: center;
`;

export default function ProductImageAndNameCell({ productLink, productTitle, productImgUrl, onRemoveButtonClick }) {
  return (
    <ProductImageAndNameCellContainer>
      <RemoveButton onClick={onRemoveButtonClick} className={'compare-popup-remove-product'}>
        {/* TODO: Add to translations */}
        Remove
        {' '}
        <Icon icon={'Cross'} />
      </RemoveButton>
      <ProductTitleLink href={productLink}>
        <ProductImage src={productImgUrl} alt={productTitle} />
        <ProductTitle>{productTitle}</ProductTitle>
      </ProductTitleLink>
    </ProductImageAndNameCellContainer>
  );
}

ProductImageAndNameCell.propTypes = {
  productLink: PropTypes.string.isRequired,
  productTitle: PropTypes.string.isRequired,
  productImgUrl: PropTypes.string.isRequired,
  onRemoveButtonClick: PropTypes.func.isRequired
};
